import { useGoogleLogin } from "@react-oauth/google";
import PropTypes from "prop-types";
import httpcommon from "../../helper/httpcommon";

const GoogleLoginButton = ({ onSuccessLogin, communityPartnerReferral = "" }) => {

    const login = useGoogleLogin({
        flow: "auth-code",
        scope: "openid email profile",
        ux_mode: "popup",
        onSuccess: async ({ code }) => {
            try {
                // Call Django backend with the Google auth code
                const res = await httpcommon.post(`user/google/`, {
                    code,
                    community_partner_referral: communityPartnerReferral || undefined,
                });
                const token = res.data?.token;

                if (token?.access) {
                    // ✅ Return token to parent (RoleLogin)
                    onSuccessLogin?.(token);
                } else {
                    alert("No tokens received from server");
                }
            } catch (e) {
                console.error(e);
                alert("Google sign-in failed");
            }
        },
        onError: () => {
            alert("Google sign-in canceled/failed");
        },
    });

    return (
        <>
{/* 
            <Divider >
                <Typography align="center" gutterBottom>OR</Typography>
                 </Divider> */}
                 <br></br>
            <button
                type="button"
                onClick={login}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    padding: "10px",
                    backgroundColor: "#fff",
                    color: " #818FAB",
                    border: "1px solid #f4f1f1",
                    borderRadius: "10px",
                    fontWeight: 500,
                    fontSize: "16px",
                    cursor: "pointer",
                    boxShadow: "0 248px 69px 0 rgba(0, 0, 0, 0.00), 0 158px 63px 0 rgba(0, 0, 0, 0.01), 0 89px 53px 0 rgba(0, 0, 0, 0.05), 0 40px 40px 0 rgba(0, 0, 0, 0.09), 0 10px 22px 0 rgba(0, 0, 0, 0.1)",
                    transition: "all .2s ease-in-out",
                    fontFamily: "Montserrat"
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#f7f7f7";
                    e.currentTarget.style.borderColor = "#ccc";
                    e.currentTarget.style.boxShadow = "0px 4px 6px rgba(239, 234, 234, 1)";
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#fff";
                    e.currentTarget.style.borderColor = "#f4f1f1";
                    e.currentTarget.style.boxShadow = "0px 2px 4px rgba(238, 230, 230, 1)";
                }}
            >
                <img
                    src="/assets/images/google.svg"
                    alt="Google Logo"
                    style={{ width: "20px", height: "20px" }}
                />
                <span>Login with Gmail</span>    </button>

        </>
    );
}

GoogleLoginButton.propTypes = {
    onSuccessLogin: PropTypes.func,
    communityPartnerReferral: PropTypes.string,
};

export default GoogleLoginButton;
